import { render, staticRenderFns } from "./ViewPropertyDetails.vue?vue&type=template&id=23b56928"
import script from "./ViewPropertyDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPropertyDetails.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports